import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      settings: {
        // title: this.$labels.account_details,
        // accordion: {
        //   open: false,
        //   toggle: false,
        // },
        sendLabel: 'update_password',
      },
      groups: {
        editAccount: {
          visible: true,
          fields: {
            // first_name: {
            //   type: 'text',
            //   model: null,
            //   placeholder: 'first_name',
            //   label: 'first_name',
            //   rules: 'required',
            //   size: 6,
            // },
            // last_name: {
            //   type: 'text',
            //   model: null,
            //   placeholder: 'last_name',
            //   label: 'last_name',
            //   rules: 'required',
            //   size: 6,
            // },
            // display_name: {
            //   type: 'text',
            //   model: null,
            //   placeholder: null,
            //   label: 'display_name',
            //   size: 6,
            // },
            email: {
              type: 'email',
              model: null,
              placeholder: 'email',
              label: 'email',
              rules: 'required|email',
              readonly: true,
              size: 12,
            },
            old_password: {
              type: 'password',
              model: null,
              placeholder: 'old_password',
              label: 'old_password',
              rules: 'required_if:password',
              vid: 'old_password',
            },
            password: {
              type: 'password',
              model: null,
              placeholder: 'new_password',
              label: 'password',
              rules: 'min:6|required_if:old_password',
              vid: 'password',
              size: 6,
            },
            repeatPassword: {
              type: 'password',
              model: null,
              placeholder: 'repeat_password',
              label: 'repeat_password',
              id: 'repeat_password',
              rules: 'required_if:password|confirmed:password',
              vid: 'repeat_password',
              size: 6,
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(['customer', 'user']),
  },
  watch: {
    customer: {
      immediate: true,
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          // this.groups.editAccount.fields.first_name.model = val.firstName && val.firstName !== '' ? val.firstName : null;
          // this.groups.editAccount.fields.last_name.model = val.lastName && val.lastName !== '' ? val.lastName : null;
          this.groups.editAccount.fields.email.model = val.email && val.email !== '' ? val.email : null;
        }
      },
    },
  },
  methods: {
    init() {

    },
    async callback() {
      const body = {
        // first_name: this.groups.editAccount.fields.first_name.model,
        // last_name: this.groups.editAccount.fields.last_name.model,
        email: this.groups.editAccount.fields.email.model,
        old_password: this.groups.editAccount.fields.old_password.model,
        password: this.groups.editAccount.fields.password.model,
        repeatPassword: this.groups.editAccount.fields.repeatPassword.model,
      };

      await this.$store.dispatch('editUser', body);
    },
  },
};
